import { ScriptTriggerResponseSchema } from "@fapinstructor/common";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { fapinstructorApi } from "../../api";

type GetTriggersParams = {
  includeSystemTriggers?: boolean | null;
  scriptId?: string | null;
};

export const TRIGGERS_QUERY_KEY = ["triggers", "list"];

async function getTriggers(params: GetTriggersParams) {
  const triggers = await fapinstructorApi
    .get("/triggers", {
      params,
    })
    .json(ScriptTriggerResponseSchema);
  return triggers;
}

export function useTriggers(params: GetTriggersParams = {}) {
  return useQuery(triggerQueryOptions(params));
}

export const triggerQueryOptions = (params: GetTriggersParams) =>
  queryOptions({
    queryKey: [...TRIGGERS_QUERY_KEY, { options: params }],
    queryFn: () => getTriggers(params),
    throwOnError: true,
  });
